import {
	NA,
	overlappingErrorMessages,
	typeLabels,
	UNKNOWN_ACTIVITY_TYPE,
	UNKNOWN_REASON,
} from 'common/OverlappingActivitiesBanner/const';
import {
	ABSENCE_ACTIVITY_TYPE,
	DEADHEAD_ACTIVITY_TYPE,
	PROTECTION_ACTIVITY_TYPE,
	WORK_ASSIGNMENT_ACTIVITY_TYPE,
} from 'constants/activityTypes';
import { standardError } from 'global/commonMessages';
import { formatDateDisplay, formatTime } from 'utils/datetime';

export const formatOverlappingDate = (dateStr, timezone) =>
	formatDateDisplay(dateStr, { timezone });

export const formatOverlappingActivities = (overlappingActivities, timezone) => {
	return overlappingActivities.map(({ fromTimestamp, toTimestamp, activity }) => {
		const isWorkAssignmentActivity = activity.__typename === WORK_ASSIGNMENT_ACTIVITY_TYPE;
		const isAbsenceActivity = activity.__typename === ABSENCE_ACTIVITY_TYPE;
		const fallbackTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		const fromStationTimezone =
			timezone === null
				? activity?.fromStation?.timezone || fallbackTimezone
				: activity?.fromStation?.timezone || timezone || fallbackTimezone;

		const toStationTimezone =
			timezone === null
				? activity?.toStation?.timezone || fallbackTimezone
				: activity?.toStation?.timezone || timezone || fallbackTimezone;

		const fromTime = formatTime(fromTimestamp, { timezone: fromStationTimezone });
		const toTime = formatTime(toTimestamp, { timezone: toStationTimezone });
		const fromDate = formatOverlappingDate(fromTimestamp, fromStationTimezone);
		const toDate = formatOverlappingDate(toTimestamp, toStationTimezone);

		if (isAbsenceActivity) {
			const reasonLabel = activity.reason?.name || UNKNOWN_REASON;
			const baseLabel = `Absence (${reasonLabel})`;

			return `${baseLabel}: ${fromDate} (${fromTime}) - ${toDate} (${toTime})`;
		}

		if (isWorkAssignmentActivity) {
			const label = typeLabels[activity.activityType] || activity.activityType;

			let fromStationCode = activity?.fromStation.code || '';
			let toStationCode = activity?.toStation.code || '';

			// Deadhead caveat
			if (
				activity.activityType === DEADHEAD_ACTIVITY_TYPE &&
				(!fromStationCode || !toStationCode)
			) {
				fromStationCode = fromStationCode || NA;
				toStationCode = toStationCode || NA;
			}

			// Protection caveat
			if (activity.activityType === PROTECTION_ACTIVITY_TYPE) {
				toStationCode = fromStationCode;
			}

			return `${label}: ${fromStationCode} ${fromDate} (${fromTime}) → ${toStationCode} ${toDate} (${toTime})`;
		}

		return UNKNOWN_ACTIVITY_TYPE;
	});
};

export const mapOverlappingActivitiesErrors = (errors = []) => {
	if (!errors || errors.length === 0) {
		return standardError;
	}

	const mappedMessages = errors.map(
		(err) => overlappingErrorMessages[err] ?? `Unexpected error: ${err}`
	);

	return {
		...standardError,
		label: mappedMessages,
	};
};
